import * as React from 'react'
import styles from './style.module.css';
import Button from '../../../design-system/lib/Button';
import { Attach, AUTO_DISPATCH, calendar_gray, calendar_time_gray, CLOSE, COD, double_top, email_icon, hashtag2, INFO_CIRCLE, input, list_gray, MAP, notes } from '../../../assets';
import DropDown from '../../../design-system/lib/DropDown';
import Modal from '../../../design-system/lib/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { Add_Service_Option, ChangeNewTravelDialoge, NewOrder_Order_setCustomField, NewTravelResetReserve, New_Order_Reset_DropOff, New_Order_Reset_DropOffs, New_Order_Reset_Pickup, New_Travel_PaymentMethod, Remove_Service_Option, ResetNewOrder, SetCodAmount, SetNotesOrder, SetReferenceID, Set_Auto_ActiveVehicleType, Set_DropOff_Inputs, Set_NewOrder_OrderType, Set_Pickup_address, Set_Service_ActiveVehicleType, Set_Service_DeliveryMethod, Set_newOrder_draft } from '../../../Redux/actions/actionNames';
import { getCenterMap } from '../../../helper/module';
import { GetVehicletypeByServiceAction } from '../../../Redux/actions/actions';
import { useTranslation } from 'react-i18next';
import Input from '../../../design-system/lib/Input';
import { Link } from 'react-router-dom';
import history from '../../../service/history';
import Typography from '../../../design-system/lib/Typography';
import { LearnMore } from '../../learnMore';
import { UseCRUDDropoffs } from '../../../hooks/useCRUD_Dropoffs';
import Radiobutton from '../../../design-system/lib/Radiobutton';
import CustomField_DropDown from '../../../CustomFields/DropDown';
import Toggle from '../../../design-system/lib/toggle';
import CustomField_Input from '../../../CustomFields/Input';
import TooltipOnro from '../../../design-system/lib/Tooltip';
import CustomField_Phone from '../../../CustomFields/phone';
import CustomField_MultiLine from '../../../CustomFields/multiLine';
import CustomField_Date from '../../../CustomFields/Date';
import CustomField_DateTime from '../../../CustomFields/DateTime';
import CustomField_file from '../../../CustomFields/file';
import CustomField_json from '../../../CustomFields/json';
import jalali from "jalali-moment";
import { checkTimestamp, get_dateFormat, get_lang } from '../../../helper/UserData/userdate';


let hardcodecustomfield = [
  {
    "id": "ord_single",
    "key": "order_title",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Title",
    "isRequired": true,
    "config": {
      "type": "singleLine",
      "minLength": 3,
      "maxLength": 50,
      "pattern": "^[A-Za-z0-9 ]+$"
    }
  },
  {
    "id": "ord_multi",
    "key": "order_description",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Description",
    "isRequired": false,
    "config": {
      "type": "multiLine",
      "minLength": 10,
      "maxLength": 300
    }
  },
  {
    "id": "ord_phone",
    "key": "contact_phone",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Contact Phone",
    "isRequired": true,
    "config": {
      "type": "phone",
      "unique": true
    }
  },
  {
    "id": "ord_email",
    "key": "contact_email",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Contact Email",
    "isRequired": false,
    "config": {
      "type": "email",
      "unique": false
    }
  },
  {
    "id": "ord_number",
    "key": "order_number",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Number",
    "isRequired": true,
    "config": {
      "type": "number",
      "unique": true,
      "min": 1,
      "max": 999999
    }
  },
  {
    "id": "ord_decimal",
    "key": "order_price",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Price",
    "isRequired": true,
    "config": {
      "type": "decimalNumber",
      "precision": 2,
      "min": 0,
      "max": 100000
    }
  },
  {
    "id": "ord_bool",
    "key": "order_has_insurance",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Has Insurance?",
    "isRequired": false,
    "config": {
      "type": "boolean"
    }
  },
  {
    "id": "ord_date",
    "key": "preferred_date",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Preferred Date",
    "isRequired": false,
    "config": {
      "type": "date"
    }
  },
  {
    "id": "ord_datetime",
    "key": "preferred_datetime",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Preferred DateTime",
    "isRequired": false,
    "config": {
      "type": "dateTime"
    }
  },
  {
    "id": "ord_select",
    "key": "order_type",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Type",
    "isRequired": true,
    "config": {
      "type": "select",
      "choices": [
        { "key": "normal", "label": "Normal" },
        { "key": "express", "label": "Express" }
      ]
    }
  },
  {
    "id": "ord_file",
    "key": "order_attachment",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Attachment",
    "isRequired": false,
    "config": {
      "type": "file",
      "maxSizeMB": 10,
      "allowedTypes": [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "text/plain"
      ]
    }
  },
  {
    "id": "ord_json",
    "key": "extra_metadata",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Extra Metadata",
    "isRequired": false,
    "config": {
      "type": "json"
    }
  }
]



function HeaderNewOrder() {
  const [dialoge, setDialoge] = React.useState(null);
  const [collapsed, setCollapsed] = React.useState(true);

  const mapRef = useSelector((state) => state.Map.mapRef)
  const center = useSelector((state) => state.Map.center)
  const activeVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const serviceOrderTypes = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType ? state.NewOrder.newOrder.service.activeVehicleType.orderTypes : [])
  const options = useSelector((state) => state.NewOrder.newOrder.service.options)
  const serviceVehicleTypes = useSelector((state) => state.SharedData.services)
  const lang = useSelector((state) => state.LocalData.lang)
  const paymentMethod = useSelector((state) => state.NewOrder.newOrder.paymentMethod.paymentMethod)
  const paymentSide = useSelector((state) => state.NewOrder.newOrder.paymentMethod.paymentSide)
  const orderTypeActive = useSelector((state) => state.NewOrder.newOrder.orderTypeActive)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const activeDeliveryMethod = useSelector((state) => state.NewOrder.newOrder.deliveryMethod)
  let { items, sEtItems } = UseCRUDDropoffs()
  const intercomData = useSelector((state) => state.SharedData.settings?.intercomData)
  const draft = useSelector((state) => state.NewOrder.newOrder.draft)
  const REFREV = useSelector((state) => state.NewOrder.newOrder.referenceID)
  const notess = useSelector((state) => state.NewOrder.newOrder.notes)
  const customField = useSelector((state) => state.NewOrder.newOrder.customField)
  const CODV = useSelector((state) => state.NewOrder.newOrder.codAmount)


 

 

  return (
    <div className={styles.ServiceNewOrderContainer}>

      <div className={styles.ServiceNewOrderFirstRow}>
        <Button icon={CLOSE} size={'Medium'} type='Secondary' onClick={() => { history.goBack(); dispatch(ResetNewOrder()) }} style={{ paddingInlineStart: "auto", paddingInlineEnd: "auto", padding: "7px", width: "14px", height: "14px" }} />

        <Typography weight='Body_Middle_Semibold' style={{ color: "rgba(36, 36, 36, 1)", marginInlineEnd: "auto" }} text={t("CreateOrder")} />



        {intercomData && <>
          <div className={styles.divider} />
          <LearnMore hastext={false} placement={"bottomEnd"} where='NewOrder' className={styles.LearnMore} />
        </>}
      </div>
  
    </div>
  )
}

export default HeaderNewOrder